import Avatar from 'components/Avatar/Avatar';
import { withAvatar } from 'viewModel/selectors/user/withAvatar';

export default withAvatar(Avatar);
